import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { screeningAction } from '../../actions/constant';
import screeningService from '../../../services/apiServices/screeningDetails/screeningDetails';
const {
  GET_FORM_ID_FOR_SCREENING_REQUEST,
  GET_FORM_ID_FOR_SCREENING_SUCCESS,
  GET_FORM_ID_FOR_SCREENING_FAILURE,
  GET_FORM_ID_FOR_SCREENING_LOADER,
} = screeningAction;

function* getFormIdForScreening(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_FORM_ID_FOR_SCREENING_LOADER });
    const response = yield call(screeningService.getAddScreeningGetFormId, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_FORM_ID_FOR_SCREENING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_FORM_ID_FOR_SCREENING_FAILURE, payload: error });
  }
}

function* getFormIdForScreeningSaga() {
  yield takeEvery(GET_FORM_ID_FOR_SCREENING_REQUEST, getFormIdForScreening);
}

export default getFormIdForScreeningSaga;
